import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";
import { AppDialogBox } from "../../common/ui/AppDialogBox";
import InterventionForm from "./InterventionForm";
import { InterventionReducerState } from "../../../interfaces/store/interventionReducerState";
import { actionTypes } from "../../../store/actionTypes/actionTypes";
import { ADMIN } from "../../../constants/admin";

const InterventionFormDilogContainer = () => {
  const dispatch = useDispatch();

  const interventionFormDilogOpen = useSelector(
    (state: { intervention: InterventionReducerState }) => state.intervention.interventionFormOpen
  );

  const dilogTitle = "Add Intervention Label";
  // to close the data extraction form dialog
  const handleDialogClose = () => {
    dispatch({
      type: actionTypes.OPEN_INTERVENTION_FORM,
      payload: false
    });
    dispatch({
      type: actionTypes.UPDATE_SELECTED_ROW_TABLE_DATA,
      payload: null,
    });
    dispatch({
      type: actionTypes.UPDATE_INTERVENTION_TABLE_DATA,
      payload: null,
    });
    dispatch({
      type: actionTypes.UPDATE_INTERVENTION_FORM_TYPE,
      payload: ADMIN.MEETING_FORM_TYPE.CREATE,
    });
  };
  return (
    <>
      <AppDialogBox
        btnText1={"test"}
        title={dilogTitle}
        isDialogOpen={interventionFormDilogOpen}
        handleDialogClose={handleDialogClose}
        className='de-form-dialog-box-container'
      >
        <Box className='de-form-container'>
          <InterventionForm handleDialogClose={handleDialogClose} />
        </Box>
      </AppDialogBox>
    </>
  );
};

export default InterventionFormDilogContainer;
